import { FC } from "react";
import { usePostHogTrackTanstackReactRouter } from "./usePostHogTrackTanstackReactRouter";

export const PostHogTrackTanstackReactRouterPageView: FC = (props) => {
  usePostHogTrackTanstackReactRouter();
  return null;
};
